import React from "react";
import { FaAndroid, FaArrowRight, FaMobileAlt } from "react-icons/fa";

function ScoreboardAndroidCard({ scoreboard }) {
  return (
    <article className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-emerald-700 p-5 text-white sm:p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="inline-flex items-center gap-2 rounded-full bg-white/15 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-white backdrop-blur-xl">
              <FaAndroid />
              {scoreboard.badge}
            </div>

            <h2 className="mt-4 font-titre text-3xl font-bold">
              {scoreboard.title}
            </h2>

            <p className="mt-2 text-sm font-bold uppercase tracking-[0.16em] text-white/55">
              {scoreboard.subtitle}
            </p>
          </div>

          <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-[1.5rem] bg-white/15 text-3xl backdrop-blur-xl">
            <FaMobileAlt />
          </div>
        </div>
      </div>

      <div className="p-5 sm:p-6">
        <div className="flex flex-col items-center gap-4 text-center">
          <a
            href={scoreboard.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex"
          >
            <img
              src={scoreboard.logo}
              alt={scoreboard.title}
              className="h-28 w-28 rounded-[2rem] object-contain shadow-lg"
            />
          </a>

          <p className="text-sm font-medium leading-7 text-slate-600 dark:text-white/60">
            {scoreboard.description}
          </p>
        </div>

        <ul className="mt-6 space-y-3">
          {scoreboard.highlights.map((highlight) => (
            <li
              key={highlight}
              className="flex gap-3 text-sm font-medium leading-6 text-slate-600 dark:text-white/60"
            >
              <span className="mt-1 h-2 w-2 shrink-0 rounded-full bg-emerald-500" />
              <span>{highlight}</span>
            </li>
          ))}
        </ul>

        <div className="mt-6 space-y-3">
          <a
            href={scoreboard.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-5 py-3 text-sm font-bold text-white transition hover:-translate-y-0.5 hover:bg-emerald-700"
          >
            {scoreboard.primaryAction}
            <FaArrowRight />
          </a>

          {/* <a
            href={scoreboard.url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex justify-center rounded-2xl border border-slate-200 bg-white p-3 transition hover:-translate-y-0.5 hover:border-emerald-200 dark:border-white/10 dark:bg-white/[0.05]"
          >
            <img
              src={scoreboard.googlePlayLogo}
              alt="Disponible sur Google Play"
              className="h-14 w-auto object-contain"
            />
          </a> */}
        </div>
      </div>
    </article>
  );
}

export default ScoreboardAndroidCard;